var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFiltroNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 11
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-filtro-new_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\xE2ngulo 140943",
    transform: "translate(49 2)",
    d: "M0 0h13v11H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-49 -2)",
    clipPath: "url(#icon-filtro-new_svg__a)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Linha 12",
    d: "M51.5 3.5h8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Linha 13",
    d: "M52.5 7.5h6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Linha 14",
    d: "M53.5 11.5h4"
  }))));
}
export default __webpack_public_path__ + "static/media/icon-filtro-new.8d8b39bc.svg";
export { SvgIconFiltroNew as ReactComponent };